<template>

    <div id="app-export-map">
        <v-btn :title="$t('title.downloadMap')" @click="downloadMap">
            <v-icon left>mdi-download</v-icon>
            {{ $t('map.download') }}
        </v-btn>
        <a id="image-download" download="map_download.png"></a>
    </div>

</template>

<script>


    import jsPDF from 'jspdf'
    import i18n from '../../plugins/i18n'
    import {TIME_RANGE} from '../../data/constants'

    export default {
        name: 'MapDownload',
        data() {
            return {}
        },
        props: {
            map: {type: Object, default: null},
        },
        computed: {
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            isLichenApp() {
                return this.$store.getters.isLichenApp
            }
        },


        methods: {
            downloadMap() {
                // cf. OpenLayers: https://openlayers.org/en/latest/examples/export-pdf.html
                let format = 'a4'
                let resolution = 72
                let dim = [297, 210]
                let width = Math.round(dim[0] * resolution / 25.4)
                let height = Math.round(dim[1] * resolution / 25.4)
                let size = this.map.getSize()
                let viewResolution = this.map.getView().getResolution()

                const _this = this
                this.map.once('rendercomplete', function () {
                    let mapCanvas = document.createElement('canvas')
                    mapCanvas.width = width
                    mapCanvas.height = height
                    let mapContext = mapCanvas.getContext('2d')

                    // export all currently selected layers
                    Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
                        if (canvas.width > 0) {
                            let opacity = canvas.parentNode.style.opacity
                            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity)
                            let transform = canvas.style.transform
                            // get and appy transform parameters to export map context
                            let matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(',').map(Number)
                            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix)
                            mapContext.drawImage(canvas, 0, 0)
                        }
                    })
                    // create pdf and add caption with species name, copyright info for SwissLichens/SwissFungi and time stamp
                    let pdf = new jsPDF('landscape', undefined, format)
                    let titlePDF = _this.$store.getters.isFungusApp ? '©' + i18n.t('structure.TitleFungi') : '©' + i18n.t('structure.TitleLichens')

                    pdf.setFontSize(10)
                    pdf.text(i18n.t('map.captionDistribution') + _this.$store.state.taxonName + ' (' + titlePDF + new Date().toLocaleString() + ')', 1, 5)
                    pdf.setFillColor(151, 14, 54)
                    pdf.rect(1, 7, 4, 4, 'F')
                    pdf.text(i18n.t('result.resultWithinTimeRange') + _this.$store.getters.yearRangeMin + '-' + _this.$store.getters.yearRangeMax, 5, 11)
                    // pdf.setFillColor(251, 142, 0) // orange
                    pdf.setFillColor(255, 143, 143)
                    pdf.rect(1, 13, 4, 4, 'F')

                    let timeExpressionMin = TIME_RANGE.min !== _this.$store.getters.yearRangeMin && _this.$store.getters.yearRangeMin != 1800 ? TIME_RANGE.min + '-' + (_this.$store.getters.yearRangeMin - 1)  + '; ' : ''
                    let timeExpressionMax = TIME_RANGE.max !== _this.$store.getters.yearRangeMax && _this.$store.getters.yearRangeMax != new Date().getFullYear() ? (_this.$store.getters.yearRangeMax + 1) + '-' + TIME_RANGE.max : ''
                    pdf.text(i18n.t('result.resultOutsideTimeRange') + timeExpressionMin + timeExpressionMax, 5, 17)
                    pdf.addImage(mapCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 20, dim[0], dim[1])


                    pdf.save('map_download.pdf')

                    // reset original map size to initial container size
                    _this.map.setSize(size)
                    _this.map.getView().setResolution(viewResolution)
                })

                // scale and reset original map size to fit available PDF dimensions
                let printSize = [width, height - 50] // -50 reserved for PDF header with species name, copyright info and map legend
                this.map.setSize(printSize)
                let scaling = Math.min(width / size[0], height / size[1])
                this.map.getView().setResolution(viewResolution / scaling)
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #app-export-map {
        margin-top: 5px;
        margin-bottom: 30px;
        float: right;
    }


</style>